import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet} from '@simpli/meta-schema'
import {ITokenCollectionResourcesHolder} from '@/model/collection/TokenCollection'
import {Token} from '@/model/resource/Token'

export class FilterTokenSchema extends DefaultSchema
  implements ITokenCollectionResourcesHolder {
  readonly name = 'FilterToken'

  readonly fieldSet: FieldSet<Token> = {}
}
